import { render } from "./DifficultyTag.vue?vue&type=template&id=39fb9bc5&scoped=true"
import script from "./DifficultyTag.vue?vue&type=script&lang=js"
export * from "./DifficultyTag.vue?vue&type=script&lang=js"

import "./DifficultyTag.vue?vue&type=style&index=0&id=39fb9bc5&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fb9bc5"]])

export default __exports__